/**
 * Format number
 *
 * @param  {*} value Input value.
 *
 * @returns {string} Formatted string.
 */
export default (value) => {
    const formatter = new Intl.NumberFormat('en-US');

    return formatter.format(value);
};
